Schulung
<template>
    <div class="cmpnnt1Class">
        <p>{{ msg }}</p>
        <p>{{ abc }}</p>
        sdf
        <slot>
        </slot>
        <p>{{ msg }}</p>
        <ul>
            {{dices}}

            <li v-for="(item, index) in dices" :key='item.id'>
                {{item.value}} asd124f
                {{index}}
            </li>
        </ul>
        <div @click="generate_dices()">ADD DICE</div>
    </div>
</template>
<!-- ############################################################################################################################################################# -->
<script>
  export default {
    name: "cmpnnt1",

    data: function () {
      return {
        msg: "component1-data",
        dice_amount: 5,
        dices: []
      };
    },
    methods: {
      generate_dices() {
        this.dice_amount = this.dice_amount + 1
        this.dices = [];
        console.log("sdhshdjsz");
        for (let i = 0; i <= this.dice_amount; i += 1) {
          this.dices[i] = {
            value: "2",
            id: i
          }
        }
      }
    },
    mounted: function () {
      this.generate_dices();
    },
    props: ["abc"]
  };
</script>
<!-- ############################################################################################################################################################# -->
<style scoped>
    p {
        color: red;
    }
</style>

15:08 heute
